import React from 'react';
import { CssBaseline, Grid } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import SpeakerSubmissionForm from './SpeakerSubmissionForm';
import SpeakerSubmissionConfirm from './SpeakerSubmissionConfirm';
import axiosInstance, { checkDeadline, EVENT_CODE, getEventId, WEB_API } from '../constatns';
import swal from '@sweetalert/with-react';

class SpeakerSubmission extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      formState: 'write',
      data: {},
      abstractId: '',
    };
    this.handleState = this.handleState.bind(this);
    this.movePage = this.movePage.bind(this);
    this.moveBackPage = this.moveBackPage.bind(this);
  }

  componentDidMount() {
    if (sessionStorage.getItem('EVENT')) {
      if (!sessionStorage.getItem('_in_user_')) {
        this.props.history.push('/signin');
      }
      // if (!checkDeadline('speakerDeadline')) {
      //   swal('The abstract submission period has ended.');
      //   this.props.history.push('/main');
      // } else {
      //   if (!sessionStorage.getItem('_in_user_')) {
      //     this.props.history.push('/signin');
      //   }
      // }
    } else {
      axiosInstance
        .get(`${WEB_API}/event/info?eventId=${getEventId()}&code=${encodeURIComponent(EVENT_CODE)}`, {
          headers: { Pragma: 'no-cache' },
        })
        .then((response) => {
          if (response.data.Item) {
            sessionStorage.setItem('EVENT_ID', getEventId());
            sessionStorage.setItem('EVENT', JSON.stringify(response.data.Item));
            if (!checkDeadline('speakerDeadline')) {
              swal('The abstract submission period has ended.');
              this.props.history.push('/main');
              return;
            }
          }
        });
    }

    // if (!sessionStorage.getItem('_in_role') || (sessionStorage.getItem('_in_role') && sessionStorage.getItem('_in_role') !== 'SCRL_MGR')) {
    //   this.props.history.push('/speaker/submission');
    // }
  }

  handleState = (type, value) => {
    this.setState(() => ({ [type]: value }));
  };

  movePage(link, _state) {
    this.props.history.push({ pathname: link, state: _state });
  }

  moveBackPage() {
    this.props.history.goBack();
  }

  render() {
    const { formState } = this.state;

    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={4} SIdx={1} />
        <Container>
          <Grid container justifyContent={'center'} spacing={4}>
            <Grid item xs={8}>
              <MainTitle>Online Submission</MainTitle>
            </Grid>
            {/* <Grid item xs={8}>
              <Preparing />
            </Grid> */}
            {formState === 'write' && (
              <SpeakerSubmissionForm
                mode={'write'}
                abstractId={this.state.abstractId}
                data={this.state.data}
                handleState={this.handleState}
                movePage={this.movePage}
                moveBackPage={this.moveBackPage}
              />
            )}
            {formState === 'confirm' && (
              <SpeakerSubmissionConfirm
                isRegister={true}
                abstractId={this.state.abstractId}
                data={this.state.data}
                handleState={this.handleState}
                movePage={this.movePage}
              />
            )}
            {formState === 'modify' && (
              <SpeakerSubmissionForm
                mode={'modify'}
                isRegister={true}
                abstractId={this.state.abstractId}
                data={this.state.data}
                handleState={this.handleState}
                movePage={this.movePage}
                moveBackPage={this.moveBackPage}
              />
            )}
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default SpeakerSubmission;
